import { CheckCircle2 } from 'lucide-react';
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'src/components/ui/button'
import { Card, CardContent } from 'src/components/ui/card';

const PaymentSuccess = () => {

  const navigate = useNavigate();

  return (
      <div className="w-full h-[90dvh]">
       <div className="flex h-screen items-center justify-center bg-gradient-to-br from-green-50 to-emerald-100">
      <Card className="w-full max-w-md rounded-2xl shadow-lg border-0">
        <CardContent className="flex flex-col items-center p-8 space-y-6">
          <CheckCircle2 className="h-20 w-20 text-green-500" />
          <h2 className="text-2xl font-bold text-gray-800">Payment Successful 🎉</h2>
          <p className="text-gray-600 text-center">
            Your order has been placed successfully. You’ll receive a confirmation email shortly.
          </p>
          <Button className="rounded-xl px-6 py-2" onClick={() => navigate("/books")}>
            Go to Books
          </Button>
        </CardContent>
      </Card>
    </div>
    </div>
  )
}

export default PaymentSuccess